var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import '../scss/frontend.scss';
import Plyr from 'plyr';
import Popup from './parts/popup-window';
import Functions from './parts/functions';
import tabsNavigation from './parts/navi-tabs';
import { anchorLinkScroll, fetchIncreaseNumberCount } from './parts/helpers';
import { initBannerSlider } from './components/swiper-init';
import PopupHandler from './parts/popup-handler';
function ready() {
    const popupInstance = new Popup();
    const functionsInstance = new Functions();
    popupInstance.init();
    const popupHandler = new PopupHandler('#banner-popup');
    popupHandler.initializePopup();
    functionsInstance.toggleScrollHeader();
    functionsInstance.toggleMenuVisibility();
    functionsInstance.similarSlider();
    functionsInstance.anchorLinks();
    tabsNavigation('.js-btn-tab', '.js-agenda-schedule');
    anchorLinkScroll('.menu-item', null, -100);
    initBannerSlider();
    document.body.addEventListener('click', (e) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const target = e.target;
        const role = (_a = target === null || target === void 0 ? void 0 : target.dataset) === null || _a === void 0 ? void 0 : _a.role;
        switch (role) {
            case 'privacy-swithcer': {
                e.preventDefault();
                const content = document.querySelector('.js-privacy-content');
                if (!target.classList.contains('privacy-showed')) {
                    target && target.classList.add('privacy-showed');
                    content && content.classList.add('privacy-showed');
                    setTimeout(() => {
                        content &&
                            content.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            });
                    }, 500);
                }
                else {
                    target && target.classList.remove('privacy-showed');
                    content && content.classList.remove('privacy-showed');
                }
                break;
            }
            case 'banner-link': {
                e.preventDefault();
                const link = e.target;
                const res = yield fetchIncreaseNumberCount(link, 'click_counter');
                if (res.success) {
                    const targetAttr = link.target || '_self';
                    if (targetAttr === '_blank') {
                        window.open(link.href, '_blank');
                    }
                    else {
                        window.location.href = link.href;
                    }
                }
            }
            default:
                break;
        }
    }));
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const videoElements = document.querySelectorAll('video');
    videoElements.forEach((el, index) => {
        const player = new Plyr(el, {
            controls: [],
            autoplay: true,
            muted: true,
            loop: { active: true },
        });
        const play = () => {
            const playPromise = isIOS ? el.play() : player.play();
            if (playPromise instanceof Promise) {
                playPromise.catch((err) => {
                    console.warn(`Autoplay failed for video #${index}:`, err);
                });
            }
        };
        el.muted = true;
        el.setAttribute('muted', '');
        if (el.readyState >= 2) {
            play();
        }
        else {
            el.addEventListener('canplay', play, { once: true });
        }
    });
}
window.document.addEventListener('DOMContentLoaded', ready);
